// --------------------------------------------------------------------------
// exhibitPopup.js
// --------------------------------------------------------------------------
// Use fancybox to ajax in exhibit details into a popup
// --------------------------------------------------------------------------

RN.exhibitPopup = function() {

  'use strict';

  function init() {
    byBehaviour('exhibit-popup').fancybox({
      type: 'ajax',
      padding: 0,
      margin: 50,
      maxWidth: 1150
    });
  }

  return {
    init: init
  };

}();